export class Editable {

    /** Indicates whether or not the resource is currently being edited. */
    public editing: boolean;

}